import { render, staticRenderFns } from "./TicketsIcon.vue?vue&type=template&id=0567fa8c&scoped=true"
var script = {}
import style0 from "./TicketsIcon.vue?vue&type=style&index=0&id=0567fa8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0567fa8c",
  null
  
)

export default component.exports